import React, { createContext, useContext, useEffect, useState, useMemo } from "react";

const CartContext = createContext(null);

const STORAGE_KEY = "atelier_rose_cart_v1";

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }, [items]);

    function addItem(product, qty = 1) {
        setItems((prev) => {
            const found = prev.find((p) => p.product_id === product.id);
            if (found) {
                return prev.map((p) =>
                    p.product_id === product.id ? { ...p, quantity: p.quantity + qty } : p
                );
            }
            return [
                ...prev,
                {
                    product_id: product.id,
                    name: product.name,
                    price: product.price,
                    quantity: qty,
                    image: product.images?.[0] || null,
                },
            ];
        });
    }

    function updateQty(product_id, quantity) {
        setItems((prev) =>
            prev
                .map((p) => (p.product_id === product_id ? { ...p, quantity } : p))
                .filter((p) => p.quantity > 0)
        );
    }

    function removeItem(product_id) {
        setItems((prev) => prev.filter((p) => p.product_id !== product_id));
    }

    function clear() {
        setItems([]);
    }

    const total = useMemo(
        () => items.reduce((sum, it) => sum + it.price * it.quantity, 0),
        [items]
    );
    const count = useMemo(
        () => items.reduce((sum, it) => sum + it.quantity, 0),
        [items]
    );

    const value = { items, addItem, updateQty, removeItem, clear, total, count };
    return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
    const ctx = useContext(CartContext);
    if (!ctx) throw new Error("useCart must be inside CartProvider");
    return ctx;
}
